import {
    Features,
    useFeatureFlagValue,
} from '@experiences/feature-flags';

import useCheckLicense from './useCheckLicense';

/**
 * Consumption dashboards and the User usage page read from the enterprise Snowflake, so they are
 * not offered to Community organizations. `EnableUsageInsightsForCommunity` is the escape hatch.
 *
 * Every entry point and every route guard for those two surfaces goes through this hook, so the
 * plan rule lives in one place.
 *
 * What the escape hatch restores: both routes, and the entry points on the legacy and V2 consumables
 * experiences. It cannot restore entry points to the revamped Community consumables page
 * (`CommunityConsumables`), which has never had a "View details" link or a User usage card of its own
 * — reaching those surfaces from there would need them built first.
 */
const useCanAccessUsageInsights = () => {
    const { isCommunity } = useCheckLicense();
    const enableUsageInsightsForCommunity = useFeatureFlagValue(Features.EnableUsageInsightsForCommunity.name);

    return !isCommunity || enableUsageInsightsForCommunity;
};

export default useCanAccessUsageInsights;
